import { useState, useEffect } from 'react';
import { QUEST_DURATION, calculateProgress } from '../utils/questUtils';

interface UseQuestReturn {
  isStarted: boolean;
  timeRemaining: number;
  progressPercentage: number;
  startQuest: () => void;
  resetQuest: () => void;
}

export const useQuest = (): UseQuestReturn => {
  const [isStarted, setIsStarted] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(QUEST_DURATION);

  const startQuest = () => {
    setIsStarted(true);
    setTimeRemaining(QUEST_DURATION);
  };

  const resetQuest = () => {
    setIsStarted(false);
    setTimeRemaining(QUEST_DURATION);
  };

  // Countdown effect
  useEffect(() => {
    if (!isStarted || timeRemaining <= 0) return;

    const timer = setInterval(() => {
      setTimeRemaining(prev => {
        if (prev <= 1) {
          setIsStarted(false); // Quest completed when timer reaches 0
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isStarted, timeRemaining]);

  const progressPercentage = calculateProgress(timeRemaining, isStarted);

  return {
    isStarted,
    timeRemaining,
    progressPercentage,
    startQuest,
    resetQuest
  };
}; 